import dot from 'dot-prop-immutable'

import * as emailAtypes from 'apps/email/emailReduxActionTypes'
import * as smsAtypes from 'apps/sms/smsReduxActionTypes'
import { billingInfoActions } from 'common/billing/redux/billingInfo'
import * as appAtypes from 'common/core/constants/appReduxActionTypes'
import { ExportSteps } from 'common/core/constants/ExportSteps'
import {
  addWhitelistingDomain,
  deleteWhitelistingDomain,
  disableUserInput,
  disconnectStripe,
  fetchSettings,
  getHandoverReceivers,
  getListTimezones,
  getWhitelistingDomains,
  handoverUpdatedNotification,
  setBotTimezone,
  setConversionsApiByChannel,
  setCurrency,
  setDisplayPreference,
  setDisplayPreferences,
  setGreeting,
  setInitialSettings,
  setLiveChatReceiver,
  setLivechatSettings,
  setMobileNotifyAdminPushEnabled,
  setPaymentNotifySettings,
  setSkipQuickCampaignsModal,
  setStripeChargeEmailNotification,
  updateAutomationPauseTime,
  updateLiveChatFilterSetting,
  updateSettingsState,
} from 'common/settings/actions'
import * as emailActionsTyped from 'common/settings/actions/emailActionsTyped'
import { connectPaypal, disconnectPaypal } from 'common/settings/actions/paypalActionsTyped'
import * as personaActionsTyped from 'common/settings/actions/personaActionsTyped'
import {
  deletePublicAPIToken,
  getPublicAPIToken,
} from 'common/settings/actions/publicAPIActionsTyped'
import * as atypes from 'common/settings/SettingsReduxActionTypes'

import { setAudienceDeletedSubscribersVisibility, updateLivechatAccountSettings } from '../actions'

export const initialState = {
  item: null,
  locales: null,
  timezones: null,
  handoverReceivers: null,
  whitelist: [], // [{domain: "manychat.com", deletable: true, fb_verified: true}, ...]
  isWhitelistLoading: false,
  isTimezonesLoading: false,
  exportBotStatus: {
    //here will be stored bot cloning statuses by account ids:
    //[account.Id]: STATUS
  },
  liveChatSnippets: [],
  optInPayload: null,
  fetching: false,
}

export default function settingsReducer(state = initialState, action) {
  switch (action.type) {
    case updateSettingsState.type: {
      return { ...state, item: action.payload.settings }
    }
    case fetchSettings.pending.type: {
      return { ...state, fetching: true }
    }
    case fetchSettings.fulfilled.type: {
      return {
        ...state,
        optInPayload: action.payload.opt_in_payload,
        item: action.payload.settings,
        fetching: false,
      }
    }
    case fetchSettings.rejected.type: {
      return { ...state, fetching: false }
    }
    case setMobileNotifyAdminPushEnabled.fulfilled.type: {
      return dot.set(state, 'item.current_user.mobile_notify_admin_push_enabled', action.payload)
    }

    case appAtypes.APP_DROP_OPTIN_REQUIRED: {
      return dot.set(state, 'item.current_user.is_opted_in', true)
    }
    case billingInfoActions.saveBillingInfo.fulfilled.type:
    case billingInfoActions.switchInvoicesSending.fulfilled.type: {
      return dot.set(state, 'item.billing_info', action.payload.billing_info)
    }
    case setLivechatSettings.fulfilled.type: {
      return dot.merge(state, 'item.current_user.livechat_settings', action.payload)
    }
    case updateLivechatAccountSettings.fulfilled.type: {
      return dot.merge(
        state,
        'item.livechat_account_settings',
        action.payload.livechat_account_settings,
      )
    }
    case handoverUpdatedNotification.type: {
      return dot.merge(state, 'item.handover', action.pyaload)
    }
    case setAudienceDeletedSubscribersVisibility.fulfilled.type: {
      return dot.set(state, 'item.audience_only_active', action.meta.arg)
    }
    case getWhitelistingDomains.fulfilled.type:
    case addWhitelistingDomain.fulfilled.type:
    case deleteWhitelistingDomain.fulfilled.type: {
      state = dot.set(state, 'isWhitelistLoading', false)
      return dot.set(state, 'whitelist', action.payload.whitelist)
    }

    case getWhitelistingDomains.pending.type:
    case addWhitelistingDomain.pending.type:
    case deleteWhitelistingDomain.pending.type: {
      return dot.set(state, 'isWhitelistLoading', true)
    }
    case addWhitelistingDomain.rejected.type:
    case deleteWhitelistingDomain.rejected.type: {
      if (action.error?.error) {
        state = dot.set(state, 'whitelistingError', action.error?.error)
      }
      return dot.set(state, 'isWhitelistLoading', false)
    }
    case getListTimezones.pending.type: {
      return dot.set(state, 'isTimezonesLoading', true)
    }
    case getListTimezones.fulfilled.type: {
      state = dot.set(state, 'isTimezonesLoading', false)
      return dot.set(state, 'timezones', action.payload)
    }
    case getListTimezones.rejected.type: {
      return dot.set(state, 'isTimezonesLoading', false)
    }

    case setBotTimezone.pending.type: {
      return dot.set(state, 'isBotTimezoneChanging', true)
    }
    case setBotTimezone.rejected.type:
    case setBotTimezone.fulfilled.type: {
      return dot.set(state, 'isBotTimezoneChanging', false)
    }

    case smsAtypes.SMS_CHANNEL_SWITCH_REQUEST: {
      return dot.set(state, 'item.isSMSSwitchError', false)
    }
    case smsAtypes.SMS_CHANNEL_SWITCH_ERROR: {
      return dot.set(state, 'item.isSMSSwitchError', true)
    }
    case emailAtypes.EMAIL_SETTINGS_SET_SENDER_NAME_RESPONSE:
    case emailAtypes.EMAIL_SETTINGS_SET_REPLY_TO_RESPONSE: {
      return dot.set(state, 'item.email', action.data.email_settings)
    }

    case setSkipQuickCampaignsModal.fulfilled.type: {
      return dot.set(state, 'item.skip_flow_templates_modal', action.meta.arg)
    }

    // EXPORT BOT
    case atypes.EXPORT_BOT_REQUEST: {
      const { accountId } = action
      return dot.set(state, ['exportBotStatus', accountId], ExportSteps.PROCESS)
    }
    case atypes.EXPORT_BOT_ERROR: {
      const { accountId } = action
      return dot.set(state, ['exportBotStatus', accountId], ExportSteps.FAIL)
    }
    case atypes.EXPORT_BOT_RESPONSE: {
      const { accountId } = action
      return dot.set(state, ['exportBotStatus', accountId], ExportSteps.SUCCESS)
    }
    case atypes.EXPORT_BOT_COMPLETE: {
      const { accountId } = action
      return dot.delete(state, ['exportBotStatus', accountId])
    }

    case updateLiveChatFilterSetting.type: {
      return dot.set(state, 'item.lc_threads_filter_enabled', action.payload)
    }

    case updateAutomationPauseTime.fulfilled.type:
      return {
        ...state,
        item: {
          ...state.item,
          automation_pause_seconds: action.meta.arg,
          livechat_account_settings: {
            ...state.item.livechat_account_settings,
          },
        },
      }

    case setDisplayPreference.type: {
      const { preference, value } = action.payload
      return dot.set(state, `item.display_preferences.${preference}`, value)
    }

    case setDisplayPreferences.type: {
      return dot.set(state, `item.display_preferences`, action.payload)
    }

    case setConversionsApiByChannel.type: {
      const { channel, value } = action.payload

      if (!state.item.conversions_api || value === null) {
        return dot.set(state, 'item.conversions_api', { [channel]: value })
      }

      return dot.merge(state, `item.conversions_api.${channel}`, value)
    }

    case setInitialSettings.type: {
      const data = {}

      // if we have settings item, we shouldn't update it
      if (!action?.payload || state.item) {
        return state
      }

      if (action.payload?.settings) {
        data.item = action.payload.settings
      }

      return { ...state, ...data }
    }

    case getHandoverReceivers.fulfilled.type: {
      return { ...state, handoverReceivers: action.payload.receivers }
    }

    case setLiveChatReceiver.fulfilled.type: {
      return {
        ...state,
        item: { ...state.item, handover: { ...state.item.handover, app_id: action.meta.arg } },
      }
    }

    case emailActionsTyped.switchEmailChannel.pending.type: {
      return {
        ...state,
        item: {
          ...state.item,
          isEmailSwitchError: false,
        },
      }
    }
    case emailActionsTyped.switchEmailChannel.rejected.type: {
      return {
        ...state,
        item: {
          ...state.item,
          isEmailSwitchError: true,
        },
      }
    }

    case emailActionsTyped.showEmailBranding.fulfilled.type:
    case emailActionsTyped.setEmailSettings.fulfilled.type: {
      return {
        ...state,
        item: {
          ...state.item,
          email: action.payload.email_settings,
        },
      }
    }

    case personaActionsTyped.usePersona.fulfilled.type: {
      return { ...state, item: { ...state.item, use_persona: action.meta.arg } }
    }

    case disconnectStripe.fulfilled.type:
    case setCurrency.fulfilled.type:
    case setPaymentNotifySettings.fulfilled.type:
    case setStripeChargeEmailNotification.fulfilled.type:
    case connectPaypal.fulfilled.type:
    case disconnectPaypal.fulfilled.type:
    case disableUserInput.fulfilled.type:
    case setGreeting.fulfilled.type: {
      return { ...state, item: action.payload.settings }
    }
    case getPublicAPIToken.fulfilled.type: {
      return {
        ...state,
        publicAPIAccessToken: action.payload.token,
      }
    }
    case deletePublicAPIToken.fulfilled.type: {
      return {
        ...state,
        publicAPIAccessToken: '',
      }
    }
  }

  return state
}
